import { render, staticRenderFns } from "./new-candidate.vue?vue&type=template&id=64d3f9ac&"
import script from "./new-candidate.vue?vue&type=script&lang=js&"
export * from "./new-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports